"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StayTunedCurrentStep = void 0;
const react_1 = __importDefault(require("react"));
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
// import { styles } from "./Dashboard.web.style";
const react_native_1 = require("react-native");
const date_fns_1 = require("date-fns");
const Dashboard_style_1 = require("./Dashboard.style");
const StayTunedCurrentStep = (props) => {
    const { filteredPatientAppointments, scrollToAktuel } = props;
    return (react_1.default.createElement(react_native_1.View, { onLayout: event => {
            const layout = event.nativeEvent.layout;
            scrollToAktuel(layout.x, layout.y, layout.width, layout.height / 2, false);
        } },
        react_1.default.createElement(react_native_1.Text, { style: [
                Dashboard_style_1.styles.heading3,
                GlobalStyles_1.globalStyles.marginTop35,
                { textTransform: 'none' }
            ] }, "Termin hat stattgefunden"),
        react_1.default.createElement(react_native_1.Text, { style: [
                Dashboard_style_1.styles.text,
                GlobalStyles_1.globalStyles.marginTop25,
                { paddingHorizontal: '20%' },
                { lineHeight: 20 }
            ] },
            "Ihr letzter Termin hat am ",
            (0, date_fns_1.format)(new Date(filteredPatientAppointments[filteredPatientAppointments.length - 1]?.startDate), 'dd.MM.yyyy'),
            " stattgefunden."),
        react_1.default.createElement(react_native_1.Text, { style: [
                Dashboard_style_1.styles.text,
                GlobalStyles_1.globalStyles.marginTop50,
                GlobalStyles_1.globalStyles.paddingHorizontal4pct,
                { paddingHorizontal: '15%' },
                { lineHeight: 20 }
            ] }, "In K\u00FCrze k\u00F6nnen Sie an dieser Stelle Ihren n\u00E4chsten Termin buchen.")));
};
exports.StayTunedCurrentStep = StayTunedCurrentStep;
